import baseAPI from '@/http'

const router = 'api/municipio/municipioevidencia'

export const cityEvidenceAPI = {
  create: (cityEvidence) => baseAPI.post(router, cityEvidence),
  update: (cityEvidence) => baseAPI.put(router, cityEvidence),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  desativarEvidencia: (id) => baseAPI.put(`${router}/desativar-evidencia/${id}`),

  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByCity: (filtros) => baseAPI.post(`${router}/list-by-municipio`, filtros)
}
